<template>
  <div class="container admin">
    <div class="menu menu-admin" role="menu">
      bioplan architekten<template v-if="isLoggedIn && userData"> - {{ userData.username }} - <a @click="logout">Logout</a></template>
      <br/><br/>
      <ul v-if="isLoggedIn">
        <li>
          <router-link :to="{ name: 'AdminUsers' }" :class="{ active: $route.name == 'AdminUsers' }">Benutzer</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AdminSlides' }" :class="{ active: $route.name == 'AdminSlides' }">Slides</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AdminPersons' }" :class="{ active: $route.name == 'AdminPersons' }">Personen</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AdminCategories' }" :class="{ active: $route.name == 'AdminCategories' }">Kategorien</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AdminEntries' }" :class="{ active: $route.name == 'AdminEntries' }">Einträge</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'AdminPages' }" :class="{ active: $route.name == 'AdminPages' }">Seiten</router-link>
        </li>
      </ul>
    </div>

    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AdminMain',
    computed: {
      ...mapGetters({
        isLoggedIn: 'auth/isLoggedIn',
        userData: 'auth/userData'
      })
    },
    methods: {
      logout () {
        this.$store.commit('auth/LOGOUT')
        this.$router.push({ name: 'Login' })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .admin .menu {
    color: white;
  }
  .admin.container {
    margin-top: 0;
  }
  .admin .content {
    color: white;
    padding: 25px;
    font-family: 'biomedium', Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: 16pt;
  }
  .admin .content input[type=text], .admin .content input[type=password], .admin .content input[type=file], .admin .content button, .admin .content textarea, .admin .content input[type=checkbox] {
    padding: 9px;
    font-size: 14pt;
    font-weight: bold;
  }
  .admin a {
    cursor: pointer;
  }
  .admin .menu {
    position: relative;
  }
  .admin table {
    border-spacing: 0;
  }
  .admin table tr td, .admin table tr th {
    border-bottom: 1px solid white;
    padding: 5px;
  }
  .admin table tr td:last-child {
    border-left: 1px solid white;
  }
  .admin table tr td a {
    margin: 0 10px;
  }
  .admin .edit-form label {
    float: left;
    width: 200px;
    font-weight: bold;
  }
  .admin .edit-form .c-chrome {
    float: left;
  }
  .admin .edit-form input:not([type=checkbox]), .admin textarea {
    width: 500px;
    margin-bottom: 5px;
  }
  .admin .edit-form .editable-input input:not([type=checkbox]) {
    width: 100%;
  }
  .admin .edit-form input[type=checkbox] {
    width: 20px;
    height: 20px;
  }
  .admin .edit-form textarea {
    height: 250px;
  }
  .admin .edit-form .boxes {
    width: 1em;
  }
  .admin .edit-form label .note a {
    color: white;
    text-decoration: underline;
    font-size: 14pt;
  }
  .admin .edit-form::after {
    content:"";
    display:block;
    clear:both;
  }
  .admin .menu.menu-admin ul li {
    float: left;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// AdminMain.vue?1e1f2f74